import { useCentralStore } from "../../../store/Central";
import { Star } from "lucide-react";
import { cn } from "../../../lib/utils/cn";
import { getClientDisplayName } from "@/lib/utils/client-utils";

export const ClientPageTitle = () => {
	const { client, favoriteClient } = useCentralStore((state) => ({
		client: state.client,
		favoriteClient: state.favoriteClient,
	}));

	if (!client) return null;

	return (
		<div
			className="flex items-center justify-center"
			data-testid="client-page-title"
		>
			<button
				className={cn(
					"flex items-center justify-center rounded-md w-8 h-8 transition-colors",
					client?.favorite
						? "text-yellow-500"
						: "text-gray-400 hover:text-gray-600"
				)}
				onClick={() => favoriteClient(client.id as string, !client.favorite)}
				aria-label={
					client?.favorite
						? "Remove from favorites"
						: "Add to favorites"
				}
			>
				<Star
					size={16}
					className={client?.favorite ? "fill-yellow-400" : ""}
				/>
			</button>

			<span className="text-md font-medium text-gray-700 px-1 py-0.5">
				{getClientDisplayName(client)}
			</span>
		</div>
	);
};